import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { clearPersistedCache } from '@/lib/query-persist';
import { useAuth } from '@/hooks/useAuth';

/**
 * Shown across the top while an admin is viewing the app as a test user, so it
 * is always obvious this is not real data and there is a one-tap way back.
 */
export function ImpersonationBanner() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const stop = useMutation({
    mutationFn: () => api('/api/admin/stop-impersonating', { method: 'POST' }),
    onSuccess: async () => {
      // Back to the admin's own session: drop the impersonated user's cache
      // (memory + persisted) and navigate in-app, no reload. See MorePage / #53.
      await clearPersistedCache();
      queryClient.clear();
      navigate('/', { replace: true });
    },
  });

  if (!auth?.impersonating) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[70] flex items-center justify-between gap-3 px-4 py-2 text-white"
      style={{ background: 'var(--warning)', paddingTop: 'max(env(safe-area-inset-top), 8px)' }}
    >
      <span className="text-[13px] font-semibold">
        Viendo como {auth.user.displayName}
      </span>
      <button
        type="button"
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="rounded-[var(--radius-pill)] bg-black/20 px-3 py-1 text-[13px] font-semibold"
      >
        Volver a mi cuenta
      </button>
    </div>
  );
}
